import Reflux from 'reflux'
import axios from 'axios'
import _ from 'lodash'

import CurrentRecipeActions from '~/actions/currentRecipe.js'

import apiUtils from '../helper/api.js'


export default class CurrentRecipeStore extends Reflux.Store {
	static getDefaultState() {
		return {
			recipeID: 0, // means loading
			recipeInstructions: [],
			recipeIngredients: [],
			showInstructionModal: false,
			showIngredientsModal: false,
			preheat_temp: '',
			description: '',
			timePrep: null,
			timeCook: null,
			timeReady: null,
			servings: null,
			link: null,
			fromWho: null,
			multiplier: null,
			yield: null
		}
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	constructor() {
		super()

		this.listenables = CurrentRecipeActions

		this.state = CurrentRecipeStore.getDefaultState()
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	get(recipeID) {
		// tag the recipe ID for later user
		this.setState({ recipeID })

		// axios.get(`${apiUtils.getApiURL()}/recipes?filter[include]=recipeIngredients')
		// axios.get(`${apiUtils.getApiURL()}/recipes/${recipeID}?filter[include]=recipeIngredients
		// &filter[include]=recipeInstructions&filter[where][recipeInstructions.is_active]=1`)
		axios.get(`${apiUtils.getApiURL()}/recipes/${recipeID}`)
			.then(
				(response) => {
					this.setState(response.data)

					// now let's get the ingredients
					this.getRecipeIngredients()

					// and the instructions
					this.getRecipeInstructions()
				}
			)
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	getRecipeIngredients() {
		// separate calls so that we can filter for the is_active=1 only
		axios.get(`${apiUtils.getApiURL()}/recipeIngredients/?filter[where][recipeID]=${this.state.recipeID}&filter[where][is_active]=1`)
			.then((responseIngredients) => {
				const recipeIngredients = responseIngredients.data.map((theIngredient) => {
					const returnItem = theIngredient

					returnItem.ingredient = (_.has(theIngredient, 'ingredients'))
						? theIngredient.ingredients.ingredient
						: ''
					returnItem.quantityLong = (_.has(theIngredient, 'quantities'))
						? theIngredient.quantities.quantity
						: '(unknown)'
					returnItem.quantityAbbrev = (_.has(theIngredient, 'quantities'))
						? theIngredient.quantities.quantityAbbrev
						: '(unknown)'

					return returnItem
				})

				this.setState({ recipeIngredients })
			})
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	getRecipeInstructions() {
		// separate calls so that we can filter for the is_active=1 only
		axios.get(`${apiUtils.getApiURL()}/recipeInstructions/?filter[where][recipeID]=${this.state.recipeID}&filter[where][isActive]=1`)
			.then(responseInstructions =>
				this.setState({ recipeInstructions: responseInstructions.data })
			)
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	reset() {
		this.setState(CurrentRecipeStore.getDefaultState())
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	deleteRecipeInstruction(recipeInstructionsID, callback) {
		axios.delete(
			`${apiUtils.getApiURL()}/recipeInstructions/${recipeInstructionsID}`,
			{
				recipeInstructionsID
			}
		)
			// now get fresh data
			.then(() => {
				callback()

				this.getRecipeInstructions()
			})
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	deleteRecipeIngredients(recipeIngredientID, callback) {
		axios.delete(
			`${apiUtils.getApiURL()}/recipeIngredients/${recipeIngredientID}`,
			{
				recipeIngredientID
			}
		)
			// now get fresh data
			.then(() => {
				callback()

				this.getRecipeIngredients()
			})
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	toggleIngredientsModal() {
		this.setState({ showIngredientsModal: !this.state.showIngredientsModal })
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	toggleInstructionModal() {
		this.setState({ showInstructionModal: !this.state.showInstructionModal })
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	addInstruction(theInstruction, theCallback) {
		const formData = {
			recipeID: this.state.recipeID,
			sequence: _.size(this.state.recipeInstructions),
			instruction: theInstruction
		}

		axios.post(`${apiUtils.getApiURL()}/recipeInstructions`, formData)
			.then(
				() => {
					this.get(this.state.recipeID)

					if (theCallback) {
						theCallback()
					}
				}
			)
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	updateInstruction(postData, theCallback) {
		const formData = {
			recipeID: this.state.recipeID,
			isActive: 1,
			sequence: _.size(this.state.recipeInstructions),
			instruction: postData.instruction,
			recipeInstructionsID: postData.recipeInstructionsID
		}

		axios.put(`${apiUtils.getApiURL()}/recipeInstructions`, formData)
			.then(
				() => {
					this.get(this.state.recipeID)

					if (theCallback) {
						theCallback()
					}
				}
			)
	}
}



// WEBPACK FOOTER //
// ./src/stores/currentRecipe.js